<template>
  <chart-card
    :standalone="false"
    :is-loaded="isLoaded['thematics' + thematic.replace(/\s/g,'')]"
    :has-error="hasError['thematics' + thematic.replace(/\s/g,'')]"
    :theme-data="themeData['thematics' + thematic.replace(/\s/g,'')]"
    :error-msg="errorMsg"
    :error-empty="errorEmpty"
  />
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import ChartCard from './ChartCard.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'LineChartsRessenti',

    /* Sous-composants utilisés par ce composant */
    components: {
      ChartCard,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: '',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
      thematic: {
        type: String,
        default: '',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        isLoaded: {
          thematicsMoi: false,
          thematicsMonEnvironnement: false,
          thematicsMesRelations: false,
        },
        hasError: {
          thematicsMoi: false,
          thematicsMonEnvironnement: false,
          thematicsMesRelations: false,
        },
        themeData: {
          thematicsMoi: {},
          thematicsMonEnvironnement: {},
          thematicsMesRelations: {},
        },
      }
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      request: function () {
        this.fetchAllData()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchAllData()
    },

    /* Fonctions internes */
    methods: {
      fetchAllData: function () {
        Object.keys(this.isLoaded).forEach((item, i) => {
          this.isLoaded[item] = false
        })
        this.lineChartData('ThematicsFromUniverseMoi')
        this.lineChartData('ThematicsFromUniverseMesRelations')
        this.lineChartData('ThematicsFromUniverseMonEnvironnement')
      },

      // Génération des couleurs pour les courbes
      getColors: function (lvlCount) {
        const colors = []
        const borderColors = []
        this.$chartColors.forEach((item, i) => {
          if (i < lvlCount) {
            colors.push('rgba(' + item.r + ',' + item.g + ',' + item.b + ', 0.4)')
            borderColors.push('rgba(' + item.r + ',' + item.g + ',' + item.b + ', 1)')
          }
        })
        return { colors: colors, borderColors: borderColors }
        /* const colors = [lvlCount]
        const borderColors = [lvlCount]
        let r = 0
        let g = 0
        let b = 0
        for (let i = 0; i < lvlCount; i++) {
          r = Math.floor(Math.random() * 256)
          g = Math.floor(Math.random() * 256)
          b = Math.floor(Math.random() * 256)
          colors[i] = 'rgba(' + r + ',' + g + ',' + b + ', 0.4)'
          borderColors[i] = 'rgba(' + r + ',' + g + ',' + b + ', 1)'
        }
        return { colors: colors, borderColors: borderColors } */
      },

      // Génération des données au format Chart.js
      lineChartData: function (dataType) {
        this.$Auth.httpRequest(
          'get',
          'api/dashboard/evolution' + dataType + this.request,
        ).then(datas => {
          let labelsCustom = []
          const datasetsCustom = []
          let min = 0
          let max = 0
          const colors = this.getColors(Object.keys(datas.data).length)
          let k = 0
          const date = []

          Object.keys(datas.data).forEach(function (key) {
            const score = []

            Object.keys(datas.data[key]).forEach(function (obj) {
              if (
                date.length !== 0 &&
                datas.data[key][obj].monthNumber - 1 !== date[date.length - 1]
              ) {
                const diff =
                  datas.data[key][obj].weekNumber - date[date.length - 1]

                for (let i = 0; i <= diff; i++) {
                  score.push(null)
                  date.push(null)
                }
              }

              const formattedDate = datas.data[key][obj].monthNumber + '/' + datas.data[key][obj].yearNumber
              const index = date.findIndex(x => x === formattedDate)

              score.push(datas.data[key][obj].score)
              if (index === -1) {
                date.push(formattedDate)
              }

              if (min === 0) {
                min = datas.data[key][obj].monthNumber
              }
              if (max < datas.data[key][obj].monthNumber) {
                max = datas.data[key][obj].monthNumber
              }
            })

            //  on assigne au label custom les dates;
            labelsCustom = date

            datasetsCustom.push({
              label: key,
              fill: false,
              lineTension: 0.1,
              backgroundColor: colors.colors[k],
              borderColor: colors.borderColors[k],
              borderCapStyle: 'butt',
              borderJoinStyle: 'miter',
              data: score,
            })

            k++
          })

          const fetch = this.isLoaded
          const err = this.hasError
          const data = this.themeData
          switch (dataType) {
            case 'ThematicsFromUniverseMoi':
              fetch.thematicsMoi = true
              err.thematicsMoi = false
              data.thematicsMoi = {
                labels: labelsCustom,
                datasets: datasetsCustom,
              }
              break
            case 'ThematicsFromUniverseMonEnvironnement':
              fetch.thematicsMonEnvironnement = true
              err.thematicsMonEnvironnement = false
              data.thematicsMonEnvironnement = {
                labels: labelsCustom,
                datasets: datasetsCustom,
              }
              break
            case 'ThematicsFromUniverseMesRelations':
              // console.log('data set à faire afficher', datasetsCustom);
              fetch.thematicsMesRelations = true
              err.thematicsMonEnvironnement = false
              data.thematicsMesRelations = {
                labels: labelsCustom,
                datasets: datasetsCustom,
              }
          }
          this.isLoaded = fetch
          this.data = data
          this.hasError = err
        }).catch((error) => {
          Object.keys(this.hasError).forEach((item, i) => {
            this.hasError[item] = true
          })
          if (this.isAdmin) {
            // console.log('Error in ' + this.$options.name + ' : ', error)
          }
          this.$emit('set-error', error)
        })
      },

    },
  }
</script>
